import { jsx as _jsx } from "react/jsx-runtime";
export const SvgTiles = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'M4 4h6v6H4zm10 0h6v6h-6zM4 14h6v6H4zm10 0h6v6h-6z' }) }));
//# sourceMappingURL=tiles.js.map